// 读数地图
import React, { useRef, useState, useEffect } from 'react';
import { renderToString } from 'react-dom/server'
import { message, Checkbox, Card, Divider, Radio, Select, TimePicker } from 'antd'
import { CloseOutlined, SaveOutlined, PlusOutlined, BlockOutlined, EditOutlined, CheckOutlined } from '@ant-design/icons';
import { Input } from 'antd'
import {
  Amap as RMap, config as AmapReactConfig, Marker as AmapMarker, Markers as AmapMarkers,
  BezierCurve,
  Scale, Toolbar, SatelliteLayer, TileLayer, LabelsLayer, LayerGroup
} from '@amap/amap-react';
import { transformGCJ2WGS, transformWGSGCJ2 } from "@/common/js/common.js" //引入公共方法
import home from "@/common/img/map/home.png" //起飞点
import waypoint from "@/common/img/map/waypoint.svg" //航点
import waypointCheck from "@/common/img/map/waypoint_check.svg" //航点
import dayjs from 'dayjs';
import TextStroke from "@/component/textStroke" //文字边框组件
import './index.css'

AmapReactConfig.key = '193db6af15a86cd8d48b102ab461b002';

function ExampleMap () {
  const mapkeys = [
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
    '86d93748cf75968bb768bfb9ff4b19fc',
  ];//天地图key
  const [choose_map_key, setChooseMapKey] = useState();
  const token = localStorage.getItem('dock_token');
  const key = '193db6af15a86cd8d48b102ab461b002';
  const mapRef = useRef();
  const [zoom, setZoom] = useState(17); //地图缩放比例
  const scale = 3875.8509003722434;
  const [mapScale, setmapScale] = useState(3875.8509003722434) // 地图比例尺
  const [center, setCenter] = useState([104.21439679761284, 30.853193398205505]);//地图中心点
  const [opacity, setOpacity] = useState(true);//切换图层
  const [waypoint_show, setWaypointShow] = useState(false);//航点编辑是否显示
  const [name_show, setNameShow] = useState(false);//编辑航点名称是否显示
  const inputRef = useRef();//航点名称 用于获取焦点

  const [takeoffpoint_show, setTakeoffpointShow] = useState(false);//起飞第编辑是否显示

  const pathData = useRef(null);
  const line_data = [
    [104.21439679761284, 30.853193398205505],
    [104.21334495921043, 30.853340460311248],
    [104.21190804335299, 30.85359853815032],
    [104.20991222333629, 30.8538197373216],
    [104.2093971781841, 30.853193719439997],
    [104.20720834175205, 30.85259487093965],
    [104.20599651885203, 30.851756915526895],
    [104.20392558586589, 30.8504950864162],
    [104.20169479948807, 30.84896615761423],
    [104.19723202391437, 30.846755371340386],
    [104.19566511310849, 30.84421341931081],
    [104.19434613323992, 30.84179054515985],
    [104.19230724400236, 30.83959859380243],
    [104.19095532674761, 30.837746663159454],
    [104.18977036255679, 30.836369720133415],
    [104.18913744905248, 30.835425736776493]
  ]

  const dronedata = [
    {
      distance1: "80",//抬升
      distance2: "80",//抬升
      latitude: 30.83583860660935,
      longitude: 104.18944751380207,
    },
    {
      distance1: "80",//抬升
      distance2: "80",//抬升
      latitude: 30.853276782854856,
      longitude: 104.21367925354703,
    },
    {
      distance1: "80",//抬升
      distance2: "80",//抬升
      latitude: 30.85346851650754,
      longitude: 104.21245974910006,
    },
  ]

  //起飞点数据
  const takeoff = {
    altitude: '0',
    latitude: '',
    longitude: '',
    takeoffheight: '0',
    type: 1
  };

  const [markers, setMarkers] = useState([]);
  const [table_types, setTableTypes] = useState([
    { value: 'jack', label: 'Jack' },
    { value: 'lucy', label: 'Lucy' }
  ]);//所有的显表类型

  const [marker_info, setMarkerInfo] = useState({
    idx: -1,
    name: '',
    distance1: '',//抬升1
    distance2: '',//抬升2
    zoom_factor: '',//变焦倍数
    pitch_angle: '',//俯仰角度
    type: null,//1 采集读数  2 测量温度
    table_type: null,//显表类型
    unit: '',//单位
    readout_range: ['', ''],//读数合理范围
    light_check: false,//照明辅助是否勾选
    light_range: [],//照明时间
    temperature_range: ['', ''],//温度合理范围
  });//当前选中的航点信息

  const [HomeMarkerInfo, setHomeMarker] = useState({
    // id: takeoff.id,
    type: 1,
    point: [center[0], center[1]],
    altitude: '',//海拔(高程)
    takeoffheight: '',//起飞高度
    cruisingspeed: '',//巡航速度
  })

  //修改markerInfo
  const SetMarkerInfoVal = (txt, val) => {
    if (txt) {
      let obj = { ...marker_info };
      obj[txt] = val;
      setMarkerInfo({ ...obj })
    } else {
      let obj = { ...val };
      setMarkerInfo({ ...obj })
    }

  }

  //新增航点
  const AddMarker = () => {
    //lnglat 地图中心点
    let info = { ...marker_info };
    let idx = -1;
    let lists = [...markers];
    if (info.idx === -1) { //未选中航点，在末尾新增
      idx = lists.length;
    } else { //已选中航点，在航点前面新增
      idx = info.idx;
      info.idx = info.idx + 1;
      setMarkerInfo({ ...info })
    }
    let obj = {
      name: '',
      point: [...center],//地图中心点
      distance1: '',//抬升1
      distance2: '',//抬升2
      zoom_factor: '',//变焦倍数
      pitch_angle: '',//俯仰角度
      type: null,//1 采集读数  2 测量温度
      table_type: null,//显表类型
      unit: '',//单位
      readout_range: ['', ''],//读数合理范围
      light_check: false,//照明辅助是否勾选
      light_range: [],//照明时间
      temperature_range: ['', ''],//温度合理范围
    }
    lists.splice(idx, 0, obj);
    for (let i = 0; i < lists.length; i++) {
      let val = lists[i];
      val.idx = i;
    }
    setMarkers([...lists]);
  }

  //航点点击执行
  const MarkerClick = async (idx) => {
    setTakeoffpointShow(false);
    let lists = [...markers];
    for (let i = 0; i < lists.length; i++) {
      let val = lists[i];
      if (i === idx) {
        if (lists[i].is_check) {
          lists[i].is_check = false;
          setWaypointShow(false);
          waypointClose();
          // return;
        } else {
          lists[i].is_check = true;
          await waypointClose();
          setWaypointShow(true);
          GetMarkerInfoFun(idx);
          // return;
        }
      } else {
        lists[i].is_check = false;
      }
    }
    setMarkers([...lists])
  }

  //航点信息赋值
  const GetMarkerInfoFun = (idx) => {
    let obj = { ...markers[idx] };
    console.log('航点信息赋值');
    console.log(obj);
    obj.idx = idx;
    SetMarkerInfoVal('', obj);
  }

  //航点拖动结束执行
  const onWaypointDragEnd = (idx, lnglat) => {
    let lists = [...markers];
    lists[idx].point = [lnglat.lng, lnglat.lat];
    if (lists[idx].is_check) {
      SetMarkerInfoVal('point', [lnglat.lng, lnglat.lat]);
    }
    setMarkers([...lists]);
  }

  //修改起飞点信息
  const SetHomeMarkerInfo = (txt, val) => {
    let obj = { ...HomeMarkerInfo };
    obj[txt] = val;
    setHomeMarker({ ...obj });
  }

  //改变地图缩放比例执行
  const onZoomChange = (_scale) => {
    setmapScale(_scale)
  }

  //航点编辑 关闭执行 处理数据
  const waypointClose = () => {
    console.log('zxhi');
    setNameShow(false);
    let info = { ...marker_info };
    console.log(info);
    let idx = marker_info.idx;
    let lists = [...markers];
    info.is_check = false;
    lists[idx] = info;
    setMarkers([...lists]);

    info.idx = -1;
    setMarkerInfo({ ...info });
  }

  //保存所有航点
  const SaveWaypoint = async () => {
    if (marker_info.idx !== -1) {
      setWaypointShow(false);
      let info = { ...marker_info };
      info.idx = -1;
      setMarkerInfo({ ...info });
    }

    let lists = [...markers];
    lists[marker_info.idx] = { ...marker_info };
    for (let i = 0; i < lists.length; i++) {
      let val = lists[i];
      if (val.is_check) {
        val.is_check = false;
      }
      console.log(val);
    }
    setMarkers([...lists]);
  }

  useEffect(() => {
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    //加载完成执行
    if (dronedata && dronedata.length > 0) {
      const dronedata_list = [];
      for (const item of dronedata) {
        if (item) {
          let d = transformGCJ2WGS({ lat: item.latitude, lon: item.longitude });
          dronedata_list.push({
            name: '',
            point: [d.lon, d.lat],
            is_check: false,
            distance1: item['distance1'],
            distance2: item['distance2'],
            zoom_factor: '',//变焦倍数
            pitch_angle: '',//俯仰角度
            type: 0,//1 采集读数  2 测量温度
            table_type: null,//显表类型
            unit: '',//单位
            readout_range: ['', ''],//读数合理范围
            light_check: false,//照明辅助是否勾选
            light_range: [],//照明时间
            temperature_range: ['', ''],//温度合理范围
          })
        }
      }
      setMarkers([...dronedata_list])
    }
    //eslint-disable-next-line
  }, [])

  //航点名称输入框自动获取焦点
  useEffect(() => {
    let num = Math.floor(Math.random() * 3)
    setChooseMapKey(num);
    if (name_show) {
      inputRef.current.focus({
        cursor: 'end'
      })
    }
    //eslint-disable-next-line
  }, [name_show, inputRef])

  return (
    <div style={{ height: '100vh' }}>
      {/* 地图 */}
      <RMap
        // mapStyle="amap://styles/whitesmoke"
        ref={mapRef}
        zoom={zoom}
        center={center}
        onZoomChange={(map) => {
          console.log('zoom改变');
          setZoom(map.getZoom());
          onZoomChange(map.getScale());
        }}
        onDragEnd={(map) => {
          console.log(map.getCenter().toArray());
          setCenter(map.getCenter().toArray())
        }}
      >
        {/* 天地图图层 */}
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=vec_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />
        <TileLayer getTileUrl={'http://t0.tianditu.gov.cn/DataServer?T=img_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} opacity={opacity} />
        <TileLayer getTileUrl={'http://t4.tianditu.gov.cn/DataServer?T=cia_w&tk=' + mapkeys[choose_map_key] + '&x=[x]&y=[y]&l=[z]'} />

        {/* 线段 */}
        {line_data.length > 0 ? (
          <BezierCurve
            path={line_data}
            isOutline={true}
            outlineColor="white"
            borderWeight={2}
            strokeColor="#00B5FF"
            lineJoin="round"
            lineCap="round"
            strokeOpacity={1}
            strokeWeight={4}
            strokeStyle="solid" // 线样式还支持 'dashed'
            // strokeStyle是dashed时有效
            // strokeDasharray={[4, 4]}  //0 设置线段粗细  1 设置线段粗细间隔
            zIndex={50}
          />) : ''}

        {/* 起飞点 */}
        {
          HomeMarkerInfo && JSON.stringify(HomeMarkerInfo) !== '{}' ? (<AmapMarker
            visiable="true"
            draggable="true"
            position={HomeMarkerInfo.point}
            zIndex={99999}
            offset={[0, 0]}
            onClick={(m) => {
              if (takeoffpoint_show) {
                setTakeoffpointShow(false);
              } else {
                console.log(marker_info);
                if (marker_info.idx !== -1) {
                  MarkerClick(marker_info.idx);
                }
                setTakeoffpointShow(true);
              }

            }}
            onDragEnd={(m) => { //拖动结束执行
              const lnglat = m.getPosition();
              SetHomeMarkerInfo('point', [lnglat.lng, lnglat.lat]);
            }}
          ><img alt='起飞点' style={{
            width: "48px",
            height: "48px"
          }} src={home}></img></AmapMarker>) : null
        }

        {/* 航点 */}
        {
          markers && markers.length > 0 ? (
            markers.map((val, idx) => {
              return (
                <AmapMarker
                  features={[]}
                  key={idx}
                  visiable="true"
                  draggable="true"
                  position={val.point}
                  extData={idx}
                  offset={[0, 11]} //偏移量
                  onClick={(m) => { //点击执行
                    MarkerClick(idx);
                  }}
                  onDragEnd={(m) => {
                    console.log('结束执行');
                    console.log(idx);
                    const lnglat = m.getPosition();
                    onWaypointDragEnd(m.getExtData(), lnglat);
                    if (markers[idx].is_check) {
                      SetMarkerInfoVal('point', [lnglat.lng, lnglat.lat]);
                    }

                  }}
                >

                  <div className='flex_row align_center'>
                    {/* is_check */}
                    <img alt="航点未选中" src={waypoint} style={{ width: '22px', height: '22px', display: (val.is_check ? 'none' : '') }}></img>
                    <img alt="航点选中" src={waypointCheck} style={{ width: '22px', height: '22px', display: (val.is_check ? '' : 'none') }}></img>
                    <span style={{ position: 'relative', top: '-7px', left: '4px' }}>
                      <span style={{
                        position: 'absolute', zIndex: 10, fontSize: '12px', fontWeight: '600',
                        color: 'white', whiteSpace: 'nowrap'
                      }}>{(idx + 1) + '' + val.name}</span>
                      <span
                        style={{
                          position: 'absolute',
                          top: '0',
                          left: '0',
                          zIndex: 1,
                          fontSize: '12px',
                          fontWeight: '600',
                          textStroke: '2px black',
                          WebkitTextStroke: '2px black',
                          whiteSpace: 'nowrap',
                          color: 'white'
                        }}>
                        {(idx + 1) + '' + val.name}
                      </span>

                    </span>
                  </div>
                </AmapMarker>
              )
            })
          ) : ''
        }
        <Scale position={{ top: '20px', right: '20px' }} /> {/* 比例尺 */}
        <Toolbar position={{ bottom: '24px', right: '20px' }} /> {/* 按钮缩放 */}

      </RMap>

      {/* 浮框 */}
      <div className="pos_abs flex_col" style={{ top: 0, height: '100%' }}>
        {/* 按钮 */}
        <div className='flex_row marL24'>
          <div>
            {/* 保存航点 */}
            <div className="marT24 pd12 radius2 pointer" style={{ background: '#1F1F1F' }} onClick={() => {
              SaveWaypoint();
            }}>
              <SaveOutlined className="w16 h16" style={{ color: 'white' }} />
            </div>
            {/* 新增航点 */}
            <div className="marT12 pd12 radius2 pointer" style={{ background: '#1F1F1F' }} onClick={() => {
              AddMarker()
            }}>
              <PlusOutlined className="w16 h16" style={{ color: 'white' }} />
            </div>
            {/* 切换地图图层 */}
            <div className="marT12 pd12 radius2 pointer" style={{ background: '#1F1F1F' }}
              onClick={() => {
                setOpacity(!opacity)
              }}
            >
              <BlockOutlined className="w16 h16" style={{ color: 'white' }} />
            </div>
          </div>
          <div className='flex_auto'></div>
        </div>
        <div className="flex_auto"></div>

        {/* 航点编辑 */}
        <div className='marL24 marB24' style={{ display: (waypoint_show ? '' : 'none'), width: '300px' }}>
          <Card bodyStyle={{ padding: '0px' }}>
            <div className='flex_col' style={{ borderBottom: '1px solid #434343' }}>
              <div className='pdTB16 pdRL24 flex_row justify_between'>
                <div className='flex align_center' style={{ height: '22px' }}>
                  <span className='fs16 fw500 marR4'>{marker_info.idx + 1}</span>
                  <span className='fs16 fw500 marR4' style={{ display: (!name_show ? '' : 'none') }}>{marker_info.name}</span>
                  <span className='pointer' style={{ display: (!name_show ? '' : 'none') }}
                    onClick={() => {
                      setNameShow(true);
                    }}>
                    <EditOutlined className="w16 h16 col_primary" />
                  </span>
                  <span className="pointer flex_row align_center" style={{ display: (name_show ? '' : 'none') }}>
                    <Input placeholder="航点名称" ref={inputRef} bordered={false} value={marker_info.name} onChange={(e) => {
                      SetMarkerInfoVal('name', e.target.value)
                    }} onPressEnter={() => {
                      setNameShow(false);
                    }} />
                    <CheckOutlined className="w16 h16 col_primary"
                      onClick={() => {
                        setNameShow(false);
                      }} />
                  </span>

                </div>
                <div className="pointer flex align_center" onClick={() => {
                  setWaypointShow(false);
                  waypointClose();
                }}>
                  <CloseOutlined />
                </div>
              </div>
            </div>

            <div className="pd24 flex_col">
              <div className='flex_row marB8'>
                <Input.Group compact className='marR16' style={{ width: '50%' }}>
                  <Input style={{ width: 'calc(100% - 34px)' }} placeholder="抬升1"
                    value={marker_info.distance1}
                    onChange={(e) => {
                      SetMarkerInfoVal('distance1', e.target.value);
                    }}
                  />
                  <Card bodyStyle={{ padding: '0px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    style={{ width: '34px', background: 'rgba(255, 255, 255, 0.04)' }}>
                    m
                  </Card>
                </Input.Group>
                <Input.Group compact className='' style={{ width: '50%' }}>
                  <Input style={{ width: 'calc(100% - 34px)' }} placeholder="抬升2"
                    value={marker_info.distance2}
                    onChange={(e) => {
                      SetMarkerInfoVal('distance2', e.target.value);
                    }}
                  />
                  <Card bodyStyle={{ padding: '0px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    style={{ width: '34px', background: 'rgba(255, 255, 255, 0.04)' }}>
                    m
                  </Card>
                </Input.Group>
              </div>
              <div className='flex_row'>
                <Input.Group compact className='marR16' style={{ width: '50%' }}>
                  <Input style={{ width: 'calc(100% - 34px)' }} placeholder="变焦倍数"
                    value={marker_info.zoom_factor}
                    onChange={(e) => {
                      SetMarkerInfoVal('zoom_factor', e.target.value);
                    }}
                  />
                  <Card bodyStyle={{ padding: '0px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    style={{ width: '34px', background: 'rgba(255, 255, 255, 0.04)' }}>
                    ×
                  </Card>
                </Input.Group>

                <Input.Group compact className='' style={{ width: '50%' }}>
                  <Input style={{ width: 'calc(100% - 34px)' }} placeholder="俯仰度数"
                    value={marker_info.pitch_angle}
                    onChange={(e) => {
                      SetMarkerInfoVal('pitch_angle', e.target.value);
                    }}
                  />
                  <Card bodyStyle={{ padding: '0px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    style={{ width: '34px', background: 'rgba(255, 255, 255, 0.04)' }}>
                    °
                  </Card>
                </Input.Group>
              </div>

              <Divider />

              <Radio.Group value={marker_info.type} onChange={(e) => {
                SetMarkerInfoVal('type', e.target.value);
              }}>
                {/* 采集读数 */}
                <Card className='marB12'
                  bodyStyle={{ background: (marker_info.type === 1 ? '#000000' : ''), padding: '0', borderRadius: '8px' }}
                  bordered={false}>
                  <div className="card_sty radius8 pd12">
                    <div className='marB8'>
                      <Radio value={1} onClick={() => {
                        if (marker_info.type === 1) {
                          SetMarkerInfoVal('type', null);
                        }
                      }}><span className='fs14 fw600'>采集读数</span></Radio>
                    </div>
                    <div className='flex_row align_center marB8'>
                      <div className="marR4 flex_shrink0">显表类型</div>
                      <div className='marR8'>:</div>
                      <Select
                        disabled={!(marker_info.type === 1)}
                        className='flex_auto'
                        value={marker_info.table_type}
                        placeholder="显表类型"
                        options={table_types}
                        onChange={(e) => {
                          SetMarkerInfoVal('table_type', e);
                        }}
                      />
                    </div>
                    <div className='flex_row align_center marB8'>
                      <div className="marR4 flex_shrink0">数据单位</div>
                      <div className='marR8'>:</div>
                      <Input disabled={!(marker_info.type === 1)}
                        placeholder="数据单位"
                        className='flex_auto'
                        value={marker_info.unit}
                        onChange={(e) => {
                          SetMarkerInfoVal('unit', e.target.value);
                        }}
                      />
                    </div>
                    <div className='flex_row align_center marB8 site-input-group-wrapper'>
                      <div className="marR4 flex_shrink0">合理范围</div>
                      <div className='marR8'>:</div>
                      <Input.Group compact className='flex_auto'>
                        <Input
                          disabled={!(marker_info.type === 1)}
                          value={marker_info.readout_range[0]}
                          style={{ width: 'calc((100% - 28px)/2)', textAlign: 'center', borderRight: (marker_info.type === 1 ? '' : 0), }}
                          onChange={(e) => {
                            let obj = { ...marker_info };
                            obj.readout_range[0] = e.target.value;
                            setMarkerInfo({ ...obj })
                          }}
                        />
                        <Input
                          className={(marker_info.type === 1 ? 'site-input-split ' : '') + 'input_sty'}
                          style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none' }} placeholder="~" disabled
                        />
                        <Input
                          disabled={!(marker_info.type === 1)}
                          className='site-input-right'
                          value={marker_info.readout_range[1]}
                          style={{ width: 'calc((100% - 28px)/2)', textAlign: 'center', borderLeft: (marker_info.type === 1 ? '' : 0) }}
                          onChange={(e) => {
                            console.log(e.target.value);
                            let obj = { ...marker_info };
                            obj.readout_range[1] = e.target.value;
                            setMarkerInfo({ ...obj })
                          }}
                        />
                      </Input.Group>
                    </div>
                    <div className='flex_row align_center marB8'>
                      <div className="marR4 flex_shrink0">照明辅助</div>
                      <div className='marR8'>:</div>
                      <div className='flex_auto flex_row align_center'>
                        <Checkbox disabled={!(marker_info.type === 1)} className='marR8' checked={marker_info.light_check}
                          onChange={(e) => {
                            SetMarkerInfoVal('light_check', e.target.checked);
                          }}></Checkbox>
                        <TimePicker.RangePicker
                          disabled={!marker_info.light_check}
                          className='flex_auto'
                          // defaultValue={[dayjs('13:30', 'HH:mm'),dayjs('16:30', 'HH:mm')]}
                          value={marker_info.light_range}
                          format="HH:mm "
                          placeholder={['', '']}
                          suffixIcon=''
                          onChange={(e) => {
                            let val = e;
                            if (!e) {
                              // dayjs(e[0]).format('HH:mm')  moment 格式转 时分
                              val = []
                            }
                            SetMarkerInfoVal('light_range', val);
                          }}
                        />
                      </div>

                    </div>
                  </div>
                </Card>

                {/* 测量温度 */}
                <Card bodyStyle={{ padding: '0', background: (marker_info.type === 2 ? '#000000' : ''), borderRadius: '8px' }} bordered={false}>
                  <div className='radius8 card_sty pd12'>
                    <div className='marB8'>
                      <Radio value={2} onClick={() => {
                        console.log('点击');
                        console.log(marker_info);
                        if (marker_info.type === 2) {
                          SetMarkerInfoVal('type', null);
                        }
                      }}>
                        <span className='fs14 fw600'>测量温度</span>
                      </Radio>
                    </div>
                    <div className='flex_row align_center marB8 site-input-group-wrapper'>
                      <div className="marR4 flex_shrink0">合理范围</div>
                      <div className='marR8'>:</div>
                      <Input.Group compact className='flex_auto'>
                        <Input
                          disabled={!(marker_info.type === 2)}
                          className={marker_info.type === 2 ? 'site-input-split ' : ''}
                          style={{ width: 'calc((100% - 67px)/2)', textAlign: 'center', borderRight: (marker_info.type === 2 ? '' : 0) }}
                        />
                        <Input
                          className={marker_info.type === 2 ? 'site-input-split ' : ''}
                          style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none', }} placeholder="~" disabled
                        />
                        <Input
                          disabled={!(marker_info.type === 2)}
                          className="site-input-right"
                          style={{ width: 'calc((100% - 67px)/2)', textAlign: 'center' }}
                        />
                        <Input
                          className={marker_info.type === 2 ? 'site-input-split ' : ''}
                          style={{ width: 40, borderLeft: 0, pointerEvents: 'none' }} placeholder="℃" disabled
                        />
                      </Input.Group>
                    </div>
                  </div>
                </Card>
              </Radio.Group>
            </div>
          </Card>
        </div>

        {/* 起飞点编辑 */}
        <div className='marL24 marB24' style={{ display: (takeoffpoint_show ? '' : 'none'), width: '300px' }}>
          <Card bodyStyle={{ padding: '0px' }}>
            <div className='flex_col' style={{ borderBottom: '1px solid #434343' }}>
              <div className='pdTB16 pdRL24 flex_row justify_between'>
                <div className='flex align_center'>
                  <span className='fs16 fw500 marR4'>起飞点</span>
                  <span className='fs16 fw500 marR4' style={{ display: (!name_show ? '' : 'none') }}>{marker_info.name}</span>
                </div>
                <div className="pointer flex align_center" onClick={() => {
                  setTakeoffpointShow(false);
                }}>
                  <CloseOutlined />
                </div>
              </div>
            </div>
            <div className="pd24 flex_col">
              <div className='flex_row align_center marB8'>
                <div className="marR4 flex_shrink0">海拔高度</div>
                <div className='marR8'>:</div>
                <Input placeholder="海拔高度"
                  className='flex_auto'
                  value={HomeMarkerInfo.altitude}
                  addonAfter="m"
                  onChange={(e) => {
                    SetHomeMarkerInfo('altitude', e.target.value);
                  }}
                />
              </div>
              <div className='flex_row align_center marB8'>
                <div className="marR4 flex_shrink0">起飞高度</div>
                <div className='marR8'>:</div>
                <Input placeholder="起飞高度"
                  className='flex_auto'
                  value={HomeMarkerInfo.takeoffheight}
                  addonAfter="m"
                  onChange={(e) => {
                    SetHomeMarkerInfo('takeoffheight', e.target.value);
                  }}
                />
              </div>
              <div className='flex_row align_center'>
                <div className="marR4 flex_shrink0">巡航速度</div>
                <div className='marR8'>:</div>
                <Input placeholder="巡航速度"
                  className='flex_auto'
                  value={HomeMarkerInfo.cruisingspeed}
                  addonAfter="m/s"
                  onChange={(e) => {
                    SetHomeMarkerInfo('cruisingspeed', e.target.value);
                  }}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ExampleMap;